import { render, staticRenderFns } from "@/components/Layout/Menu/Gestores/Siniestros/Editar_siniestros/Editar_siniestros.html?vue&type=template&id=058188d5&scoped=true&"
import script from "@/components/Layout/Menu/Gestores/Siniestros/Editar_siniestros/Editar_siniestros.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Gestores/Siniestros/Editar_siniestros/Editar_siniestros.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Gestores/Siniestros/Editar_siniestros/Editar_siniestros.css?vue&type=style&index=0&id=058188d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058188d5",
  null
  
)

export default component.exports